<template>
  <v-container class="fluid-max-width">
    <p v-if="user" class="user pa-6">
      <span>Hallo, </span>
      <br />
      <span class="user-name primary--text">{{ user.first_name }}</span>
      <br />
      <span class="user-name primary--text">{{ user.last_name }}.</span>
      <br />
      <span class="company">{{ user.company.name }}</span>
    </p>
    <h4 class="mb-2 text-center">Meine letzten Schachtkonfigurationen</h4>
    <v-container class="pa-3 mb-6">
      <ShaftGrid
        :shafts="latestShafts"
        showAdd="true"
        @addClick="onAddClicked"
        :isLoading="isLoadingSites"
      />
    </v-container>
    <h4 class="mb-2 text-center">Aktuelle Baustellen</h4>
    <v-list v-if="!isLoadingSites">
      <v-list-item
        two-line
        v-for="site in topSites"
        :key="site.id"
        class="grey lighten-3 ma-2 mx-6"
        :to="'/baustellen/' + site.id"
      >
        <v-list-item-content>
          <v-list-item-title>{{ site.name }}</v-list-item-title>
          <v-list-item-subtitle
            >{{ site.street }}<span v-if="site.street">,</span>
            {{ site.postal_code }} {{ site.city }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="mt-6" v-else>
      <v-skeleton-loader
        v-for="n in 5"
        :key="n"
        class="ma-2 mx-6"
        height="64"
        type="image"
        tile
      ></v-skeleton-loader>
    </div>
    <div v-if="!topSites || topSites.length === 0">
      <p class="text-center pb-3">
        {{
          isOnline
            ? 'Keine Baustellen vorhanden'
            : 'Keine Internetverbindung. Bitte Verbindung herstellen.'
        }}
      </p>
      <div class="mx-2 my-6 text-center" v-if="isOnline">
        <v-btn depressed color="primary" to="/baustelle/neu"
          >Baustelle hinzufügen</v-btn
        >
      </div>
    </div>
    <div class="mx-2 my-6 text-center" v-else>
      <v-btn depressed color="primary" to="/baustellen">Alle Baustellen</v-btn>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ShaftGrid from '@/components/ShaftGrid.vue';

export default {
  name: 'Home',
  components: { ShaftGrid },
  data: () => ({
    isLoadingSites: false,
    minLoadingDelay: 750,
  }),
  computed: {
    ...mapGetters([
      'isLoggedIn',
      'user',
      'sites',
      'latestShafts',
      'showLoading',
    ]),
    topSites() {
      if (!this.sites) return [];
      return this.sites.slice(0, 5);
    },
    isOnline() {
      return navigator.onLine;
    },
  },
  async created() {
    const startTime = performance.now();

    if (this.topSites.length > 0 || this.latestShafts?.length > 0) {
      await this.setLoading(false);
    } else this.isLoadingSites = true;

    await this.autoLogin();
    await this.setLoading(false);

    await Promise.allSettled([
      this.getSites(),
      this.getLatestShafts(),
      this.getSelectChoices(),
    ]);

    if (this.isLoadingSites) {
      const endTime = performance.now();
      if (endTime - startTime > this.minLoadingDelay)
        this.isLoadingSites = false;
      else
        setTimeout(
          () => (this.isLoadingSites = false),
          this.minLoadingDelay - (endTime - startTime),
        );
    }
  },
  methods: {
    ...mapActions([
      'getUser',
      'getSites',
      'getLatestShafts',
      'getSelectChoices',
      'autoLogin',
      'setLoading',
    ]),
    onAddClicked() {
      this.$router.push('/schacht/add');
    },
  },
};
</script>

<style scoped>
.user span {
  font-size: 24pt;
  line-height: 24pt;
}

.user-name {
  font-family: Playfair Display;
}

.company {
  font-size: 16pt !important;
  display: flex;
  align-items: center;
}

.company::after {
  content: '';
  flex: 1;
  margin-left: 1rem;
  height: 1px;
  background-color: #c41230;
}
</style>
